import * as _ from 'underscore';

import { Module } from '../Module';

// NOTE: when using these directives, make sure the element is styled so that the properties will be respected
// For example, make sure element is styled with "position: absolute"

interface IStyleDirective {
  name: string;
  style: string;
}

const directives: IStyleDirective[] = [
  { name: 'tbBottom',        style: 'bottom' },
  { name: 'tbHeight',        style: 'height' },
  { name: 'tbLeft',          style: 'left' },
  { name: 'tbLineHeight',    style: 'line-height' },
  { name: 'tbMarginBottom',  style: 'margin-bottom' },
  { name: 'tbMarginLeft',    style: 'margin-left' },
  { name: 'tbMarginRight',   style: 'margin-right' },
  { name: 'tbMarginTop',     style: 'margin-top' },
  { name: 'tbMaxHeight',     style: 'max-height' },
  { name: 'tbMinHeight',     style: 'min-height' },
  { name: 'tbMaxWidth',      style: 'max-width' },
  { name: 'tbMinWidth',      style: 'min-width' },
  { name: 'tbRight',         style: 'right' },
  { name: 'tbTop',           style: 'top' },
  { name: 'tbWidth',         style: 'width' }
];

_.each(directives, (directive: IStyleDirective) => {
  Module.instance().directive(directive.name,
    () => {
      return {
        restrict: 'A',
        link: (scope: ng.IScope, element: JQuery, attributes: ng.IAttributes) => {
          scope.$watch(attributes[directive.name], (value: any) => {
            element.css(directive.style, _.isNumber(value) ? (value + 'px') : _.isUndefined(value) ? null : value);
          });
        }
      };
    }
  );
});
